import UnstyledAnchor from "components/common/UnstyledAnchor";
import paths from "config/routePaths";
import Authorization from "policies/Authorization";
import React from "react";
import styled from "styled-components";

const Tooltip = styled.div`
  max-width: 100%;
  overflow: auto;
  word-wrap: break-word;
  display: inline-block;
  font-size: 12px;
`;

const AvailabilityOverridesLink = styled(UnstyledAnchor)({
  fontWeight: "normal",
});

export default function UnavailabilityTooltip({ activeTarget, policy }) {
  const [, line, shift] = activeTarget.dataset.eventId.match(/resourcetimerange-\$(.*)\$(.*)\$-(.*)/);

  const renderDefaultAvailabilityLink = () => {
    if (!policy.canUpdate(Authorization.EntityTypes.DefaultAvailability)) {
      return null;
    }

    return (
      <>
        To change its availability, go to{" "}
        <AvailabilityOverridesLink
          data-testid="availability-overrides-link"
          href={paths.availabilityOverrides}
          target="_blank"
        >
          Availability overrides
        </AvailabilityOverridesLink>
        .
      </>
    );
  };

  return (
    <Tooltip data-testid="tooltip">
      {shift} on {line} is not available. {renderDefaultAvailabilityLink()}
    </Tooltip>
  );
}
